import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import PageLoading from '../components/common/page-loading/page-loading';
import { useStores } from '../components/common/root-store-provider/root-store-provider';
import page from '../components/pages/page/page';
import { routes } from '../constants/navigation';

const Index = observer(() => {
  const router = useRouter();

  const { authStore } = useStores();
  const { user, setLoginedByWinback, access_code } = authStore;
  const { query, isReady } = router;

  const emailToken =
    typeof query['email_token'] === 'string' ? query['email_token'] : undefined;

  const accessCode =
    typeof query['access_code'] === 'string' ? query['access_code'] : undefined;

  const redirect = user !== undefined && isReady && emailToken === undefined;

  useEffect(() => {
    (async () => {
      try {
        if (emailToken) {
          await authStore.loginByEmailToken({
            emailToken: emailToken,
          });
        }
      } catch (error) {
        if (error) {
          const newQuery = { ...query };
          delete newQuery['email_token'];
          delete newQuery['access_code'];
          // noinspection JSIgnoredPromiseFromCall
          router.replace({ pathname: routes.quiz, query: newQuery });
        }
      }
    })();
  }, [authStore, query, emailToken, router]);

  useEffect(
    () => {
      if (emailToken && (accessCode || access_code)) {
        !access_code && accessCode && authStore.setAccessCode(accessCode);
        setLoginedByWinback(true);
        const newQuery = { ...query };
        delete newQuery['email_token'];
        // noinspection JSIgnoredPromiseFromCall
        router.replace({ pathname: routes.newPlanPaywall, query: newQuery });
      }
    },
    // https://github.com/vercel/next.js/issues/18127
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [emailToken, user],
  );

  useEffect(
    () => {
      if (redirect) {
        console.log(redirect);
        if (user) {
          // noinspection JSIgnoredPromiseFromCall
          router.replace(routes.newPlanPaywall);
        } else {
          console.log(user);
          // noinspection JSIgnoredPromiseFromCall
          router.replace(routes.quiz);
        }
      }
    },
    // https://github.com/vercel/next.js/issues/18127
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, user?.paidSubscriber],
  );

  return <PageLoading />;
});

export default page(Index);
